/* BULKD — inject the one-time price as a struck "was" compare on the
   subscribe (Membership) option, mirroring the NZ Supps subscribe card
   ($61.00 -> $42.70). Seal renders only one price per option, so we copy
   the one-time price across. Idempotent; re-runs when Seal re-renders. */
(function () {
  function inject() {
    var c = document.querySelector('.sealsubs-container');
    if (!c) return;
    var otMoney = c.querySelector('.sls-one-time-price .sls-price .money');
    var memPrice = c.querySelector('.sls-selling-plan-group-price .sls-price');
    if (!otMoney || !memPrice) return;
    var was = otMoney.textContent.trim();
    if (!was) return;
    var existing = memPrice.querySelector('.bulkd-seal-was');
    if (existing) { if (existing.textContent !== was) existing.textContent = was; return; }
    var s = document.createElement('s');
    s.className = 'bulkd-seal-was';
    s.textContent = was;
    var money = memPrice.querySelector('.money');
    if (money) memPrice.insertBefore(s, money); else memPrice.prepend(s);
  }
  function schedule() { inject(); [60, 250, 600, 1200].forEach(function (t) { setTimeout(inject, t); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule); else schedule();
  document.addEventListener('shopify:section:load', schedule);
  // Seal re-renders the widget asynchronously — re-inject on any subtree change.
  var mo = new MutationObserver(function () { inject(); });
  (function observe() {
    var c = document.querySelector('.sealsubs-container');
    if (c) mo.observe(c, { childList: true, subtree: true });
    else setTimeout(observe, 300);
  })();
})();
